import { Instance, types } from 'mobx-state-tree';

const RateBaseModel = types.model('Rate', {
  score: types.optional(types.number, 0),
  created_at: types.optional(types.string, ''),
  source: types.optional(
    types.enumeration(['gis', 'tenant'] as const),
    'tenant'
  ),
});

export const RateModel = types.snapshotProcessor(RateBaseModel, {
  preProcessor(sn: Partial<Instance<typeof RateBaseModel>>) {
    return {
      ...sn,
      score: sn.score ?? 0,
    };
  },
});
